<script>
	export let entity_id;
	export let entity_url;
</script>

<img class="media-card-entity" src={entity_url} alt="card" />

<style>
	.media-card-entity {
		display: block;
		border-radius: 0.5rem;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 5px;
		max-width: 100%;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	@media (max-width: 700px) {
		.media-card-entity {
			padding-bottom: 13px !important;
			padding-top: 13px !important;
		}
	}
</style>
